<template>
  <div>
    <jazzicon v-if="$user && $user.registered" :address="$user._id" :diameter="25" @click.native="goProfile" />
    <jazzicon v-if="$user && !$user.registered" address="63492e4ec177dca76da704a9" :diameter="25" @click.native="goProfile" />
  </div>

<!--  Possible canvi d'user._id cap a correu o altre variable-->
</template>

<script>
import Jazzicon from 'vue-jazzicon';
export default {
    name: "ProfileAvatar",
    components: {
        [Jazzicon.name]: Jazzicon
    },
    methods: {
        goProfile () {
            if (this.$router.history.current.name !== "profile") {
                this.$router.push({name: 'profile', replace: true});
            }
        },
    },
};
</script>

<style scoped>
.avatar-icon {
  text-align: center;
  color: #ffffff;
  border-radius: 50%;
}
</style>
